<div class="main-container main-page-content ym-min-h-full ym-h-full ym-display-flex" *ngIf="!isLoading"
    [@routeAnimations]="prepareRoute(outlet)">
    <div class="wrapper ym-bg-white ym-w-full ym-display-flex ym-flex-direction-column">
        <app-home-topbar [userDocument]="userDocument" class="ym-sticky ym-top-0 ym-z-index-3 ym-relative"
            *ngIf="hideTopbar"></app-home-topbar>
        <app-sidebar [organisationDocument]="organisationDocument" *ngIf="organisationDocument"></app-sidebar>
        <div class="ym-h-full">
            <router-outlet #outlet="outlet"></router-outlet>
        </div>
        <app-bottombar class="ym-sticky ym-bottom-0 ym-z-index-3 ym-relative" *ngIf="!hideNavigation"></app-bottombar>
    </div>
</div>


<app-global-overlays *ngIf="!isLoading && userDocument"></app-global-overlays>